<template>
  <v-card class="mx-auto" outlined :loading="loading">
      <template slot="progress">
        <v-progress-linear color="deep-purple" height="3" indeterminate></v-progress-linear>
      </template>
      <v-list-item three-line >
        <v-list-item-content>
          <div class="text-overline text-center">{{titolo}}</div>
          <v-list-item-title>
          </v-list-item-title>
          <v-list-item-content>
            <apexchart type="pie" :options="chartOptions" :series="seriesQ"></apexchart>
          </v-list-item-content>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions class="d-flex justify-space-around">
      </v-card-actions>
    </v-card>    
  </template>

<script>

export default {
  components: {
  },
  props: {
    aree: Array,
    titolo: String,
    loading: Boolean
  },
  data() {
    return {
      filter: null,
      espanso: false
    }
  },
  computed: {
    seriesQ() {
      return this.aree.map(x => x.count)
    },
    seriesV() {
      return []
    },
    seriesLabels() {
      return this.aree ? this.aree.map(x => x.area) : []
    },    
    chartOptions() {
      return {
        chart: {
          type: 'pie'
        },
        labels: this.seriesLabels
      }
    }    
  }
}

</script>